import type { InvoiceStatus } from '../../types/invoice';

/** List view status column: badge colors and copy (invoices table + help modal). */
export const INVOICE_LIST_STATUS_META: Record<
    InvoiceStatus,
    { colorScheme: string; tooltip: string; modalExplanation: string }
> = {
    flagged: {
        colorScheme: 'red',
        tooltip: 'Needs review before it can be submitted to NEX.',
        modalExplanation:
            'The invoice is still in review. It has not been successfully submitted to NEX yet—address any blocking issues (such as RO, math, or return-slip line matching) and submit when ready.',
    },
    submitted: {
        colorScheme: 'green',
        tooltip: 'Successfully submitted to NEX.',
        modalExplanation:
            'The invoice was submitted to NEX and the submission completed successfully.',
    },
    manually_submitted: {
        colorScheme: 'green',
        tooltip: 'Submitted to NEX after reviewing necessary flags.',
        modalExplanation:
            'The invoice was submitted to NEX using the manual submit path—often after reviewing flags or differences that did not block submission.',
    },
};

export function getInvoiceListStatusTooltip(status: InvoiceStatus): string {
    return INVOICE_LIST_STATUS_META[status].tooltip;
}
